<mat-error
  class="fk-font-normal fk-text-11px fk-text-rose-500 ignore-dark-color tw-mt-[-5px] fk-mb-10px"
>
  <!-- invalid -->
  <div>
    <ng-container *ngIf="errMsg && control?.invalid && control?.touched">
      <i
        class="mdi mdi-15px fk-mx-1 mdi-arrow-up-circle fk-relative fk-text-rose-500 ignore-dark-color"
      ></i>
      <span class="fk-font-medium fk-text-11px" [innerHTML]="errMsg"></span>
    </ng-container>
  </div>
</mat-error>
